export const environment = {
    production: true,
    hmr: false,
    appMetadata: {
        appDomain: {
            title: 'wm.daptech.vn',
            owner: 'wm.daptech.vn',
            logo: 'assets/images/logo-dapfood-x-w.png',
        }
    },
    apiDomain: {
        gateway: 'https://wmapi.friends.vn',
        authenticationEndpoint: 'https://wmaccount.friends.vn',
        authorizationEndpoint: 'https://wmapi.friends.vn/authorization.api',
        fileEndpoint: 'https://wmapi.friends.vn/file.api',
        notificationEndpoint: 'https://wmnotification.friends.vn',
        dapFoodEndPoint: 'https://wmapi.friends.vn/dapfood.api',
        dapWorkEndPoint: 'https://wmapi.friends.vn/work.api',
        documentServer: 'https://documentserver.friends.vn',
    },
    clientDomain: {
        appDomain: 'https://wm.daptech.vn',
        qthtDomain: 'https://wmadmin.friends.vn',
        friendDomain: 'https://wm.friends.vn',
        idPhanhe: 3,
    },
    authenticationSettings: {
        clientId: 'dapfood',
        issuer: 'https://wmaccount.friends.vn'
    },
    systemLogSetting: {
        enabled: false
    },
    signalr: {
        clientKey: 'dapfood',
        endpoint: '',
        linkDownloadClientApp: ''
    },
    signalrConfig: {
        hub: {
            notification: 'NotificationHub'
        },
        action: {
            notificationCreated: '',
            viewUpdated: ''
        }
    },
    firebaseConfig: {
        apiKey: 'AIzaSyBSkn5jUqD0N4PiiDEhsWyfPIws6TyNUho',
        authDomain: 'dapfood-firebase.firebaseapp.com',
        databaseURL: 'https://dapfood-firebase.firebaseio.com',
        projectId: 'dapfood-firebase',
        storageBucket: 'dapfood-firebase.appspot.com',
        messagingSenderId: '1088787441716',
        appId: '1:1088787441716:web:329c0dfd4356195f98c261',
        measurementId: 'G-RVEWV87V1P'
    }
}